/**
 * Human-readable text for an axios error. Handles FastAPI's list-shaped 422 `detail` (a list of
 * {msg, loc, ...}) so a validation error never renders as "[object Object]" (the favicon 422 fix,
 * commit 8de53b5f). Shared by ImportedSiteSettingsPanel and the clone-block handlers.
 */
export const errText = (e: any): string => {
  const d = e?.response?.data?.detail;
  if (typeof d === 'string' && d) return d;
  // FastAPI validation errors arrive as a list of {msg, loc, ...}; never stringify an object.
  if (Array.isArray(d)) {
    const msgs = d.map((x: any) => (x && typeof x.msg === 'string' ? x.msg : '')).filter(Boolean);
    if (msgs.length) return msgs.join('; ');
  }
  return e?.message || 'unknown error';
};
